// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import "ag-grid-community/styles/ag-grid.css"; // Mandatory CSS required by the grid
// import "ag-grid-community/styles/ag-theme-quartz.css"; // Optional Theme applied to the grid
// import { AgGridReact } from "ag-grid-react"; // AG Grid Component
// import { SettingsAPI, VariantsAPI } from "api";
// import CardDropdown from "components/common/CardDropdown";
// import IconButton from "components/common/IconButton";
// import TableHeaderDropdown from "components/common/TableHeaderDropdown";
// import { settings } from "config";
// import React, { useCallback, useRef, useState } from "react";
// import { Card, Dropdown, Form, OverlayTrigger, Tooltip } from "react-bootstrap";
// import { MdOutlineModeEdit } from "react-icons/md";
// import { useNavigate } from "react-router-dom";
// import { CONSTANT_ROUTES } from "routes";
// import {
//   resetColumnState,
//   restoreColumnState,
//   saveColumnState,
// } from "utils/tablesUtils";
// import "./styles.css";
// import PageTitle from "utils/PageTitle";

// export default function GeneralTable() {
//   let isDarkBool = localStorage.getItem("isDark") === true;
//   let isDarkTheme = localStorage.getItem("theme") === "dark";
//   let auto = localStorage.getItem("theme") === "auto";
//   const navigate = useNavigate();
//   const columnApiRef = useRef();
//   const gridRef = useRef();
//   // let gridApi;

//   // Column Definitions: Defines the columns to be displayed.
//   const [colDefs, setColDefs] = useState([
//     {
//       field: "module",
//       headerName: "Module",
//       rowGroup: true,
//       hide: true, // hide it from the main columns since it appears as a group
//     },
//     {
//       field: "caption",
//       headerName: "Name",
//       flex: 9,
//     },
//     {
//       field: "value",
//       headerName: "Value",
//       flex: 9,
//     },
//   ]);

//   const handleRowClick = (data) => {
//     if (data) {
//       navigate(`${CONSTANT_ROUTES.SETTING_GENERAL_UPDATE}`, { state: data });
//     }
//   };

//   const defaultColDef = {
//     sortable: true,
//     filter: true,
//     enableRowGroup: true,
//     // floatingFilter: true,
//     // flex: 1,
//     // rowDrag: true,
//   };

//   //   ===============Custom Api Call start================

//   let gridApi;
//   let columnApi;

//   const onGridReady = useCallback(
//     (e) => {
//       gridApi = e.api;
//       columnApi = e.columnApi;
//       restoreState();
//       SettingsAPI.get().then((res) => {
//         e.api.applyTransaction({
//           add: res?.data?.data.sort((a, b) => a.sortOrder - b.sortOrder),
//         });
//       });
//     },
//     [window]
//   );

//   const saveState = useCallback(() => {
//     saveColumnState("general-setting", columnApiRef);
//   }, []);

//   const restoreState = useCallback(() => {
//     restoreColumnState("general-setting", columnApiRef);
//   }, []);

//   const resetState = useCallback(() => {
//     resetColumnState("general-setting", columnApiRef);
//   }, []);

//   const onFilterTextBoxChanged = useCallback(() => {
//     columnApiRef.current.api.setGridOption(
//       "quickFilterText",
//       document.getElementById("filter-text-box").value
//     );
//   }, []);

//   return (
//     <div>
//       {/* <div className="py-2">
//         <BreadCrumb />
//       </div> */}

//       <PageTitle name="Settings | General" />

//       <div
//         className={`${
//           isDarkBool || isDarkTheme || auto
//             ? "ag-theme-quartz-dark"
//             : "ag-theme-quartz"
//         } rounded-0`} // applying the grid theme
//         // style={{ height: "100vh" }} // the grid will fill the size of the parent container
//       >
//         <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
//           <Card.Header className="d-flex justify-content-between align-items-center">
//             <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
//               {" "}
//               Settings | General
//             </h5>
//             <div className="d-flex align-items-center gap-2">
//               <Form className="position-relative">
//                 <FontAwesomeIcon
//                   icon="search"
//                   className="position-absolute text-400 search-box-icon"
//                   style={{
//                     left: "10px",
//                     top: "50%",
//                     transform: "translateY(-50%)",
//                   }}
//                 />
//                 <Form.Control
//                   type="search"
//                   placeholder="Search..."
//                   style={{
//                     paddingLeft: "30px",
//                   }}
//                   aria-label="Search"
//                   id="filter-text-box"
//                   className="rounded-pill search-input"
//                   onInput={onFilterTextBoxChanged}
//                 />
//               </Form>
//               {/* <OverlayTrigger
//                 overlay={
//                   <Tooltip
//                     style={{ position: "fixed" }}
//                     id="overlay-trigger-example"
//                   >
//                     New
//                   </Tooltip>
//                 }
//               >
//                 <IconButton
//                   variant="falcon-default"
//                   size="sm"
//                   icon="plus"
//                   transform="shrink-3"
//                   onClick={() => navigate(CONSTANT_ROUTES.VARIANTS_ADD)}
//                 >
//                   <span className="d-none d-sm-inline-block ms-1">New</span>
//                 </IconButton>
//               </OverlayTrigger> */}
//               <TableHeaderDropdown>
//                 <div className="py-2">
//                   <Dropdown.Item
//                     onClick={saveState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Save State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={restoreState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Restore State
//                   </Dropdown.Item>
//                   <Dropdown.Item
//                     onClick={resetState}
//                     className="d-flex align-items-center gap-2 py-2"
//                   >
//                     Reset State
//                   </Dropdown.Item>
//                 </div>
//               </TableHeaderDropdown>
//             </div>
//           </Card.Header>

//           <Card.Body className="p-0">
//             <AgGridReact
//               // rowData={rowData}
//               ref={columnApiRef}
//               onGridReady={onGridReady}
//               pagination
//               paginationPageSize={settings.paginationSize}
//               columnDefs={colDefs}
//               defaultColDef={{
//                 enableRowGroup: true,
//               }}
//               onRowDoubleClicked={(params) => handleRowClick(params.data)}
//               overlayNoRowsTemplate="Nothing found - Looks empty over here"
//               groupDisplayType="groupRows"
//             />
//           </Card.Body>
//         </Card>
//       </div>
//     </div>
//   );
// }
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import { AgGridReact } from "ag-grid-react";
import { SettingsAPI } from "api";
import TableHeaderDropdown from "components/common/TableHeaderDropdown";
import { settings } from "config";
import React, { useCallback, useEffect, useRef, useState } from "react";
import { Accordion, Button, Card, Dropdown, Form } from "react-bootstrap";
import { useNavigate } from "react-router-dom";
import { CONSTANT_ROUTES } from "routes";
import {
  resetColumnState,
  restoreColumnState,
  saveColumnState,
} from "utils/tablesUtils";
import "./styles.css";
import PageTitle from "utils/PageTitle";
import BreadCrumbTable from "components/breadcrumb/BreadCrumbTable";

export default function GeneralTable() {
  const isDark =
    localStorage.getItem("isDark") === "true" ||
    localStorage.getItem("theme") === "dark" ||
    localStorage.getItem("theme") === "auto";

  const navigate = useNavigate();
  const columnApiRef = useRef();
  const [originalData, setOriginalData] = useState([]);
  const [groupedData, setGroupedData] = useState({});

  const colDefs = [
    { field: "caption", headerName: "Name", flex: 3 },
    { field: "value", headerName: "Value", flex: 9 },
  ];

  const defaultColDef = {
    sortable: true,
    filter: true,
    resizable: true,
    cellClass: "cell-ellipsis",
  };

  const handleRowClick = (data) => {
    if (data) {
      navigate(`${CONSTANT_ROUTES.SETTING_GENERAL_UPDATE}`, { state: data });
    }
  };

  const groupByModule = (data) => {
    const grouped = {};
    data.forEach((item) => {
      const key = item.module || "Uncategorized";
      grouped[key] = grouped[key] || [];
      grouped[key].push(item);
    });
    return grouped;
  };

  const gridApiRef = useRef(null);

  // const fetchData = useCallback(() => {
  //   SettingsAPI.get().then((res) => {
  //     const sorted = res?.data?.data?.sort((a, b) => a.sortOrder - b.sortOrder);
  //     setOriginalData(sorted);
  //     setGroupedData(groupByModule(sorted));
  //   });
  // }, []);

  const [loading, setLoading] = useState(true);

  const fetchData = useCallback(() => {
    setLoading(true);
    SettingsAPI.get()
      .then((res) => {
        const sorted = res?.data?.data?.sort(
          (a, b) => a.sortOrder - b.sortOrder
        );
        setOriginalData(sorted);
        setGroupedData(groupByModule(sorted));
      })
      .finally(() => {
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    fetchData();
  }, [fetchData]);

  const onFilterTextBoxChanged = (e) => {
    const value = e.target.value.toLowerCase();
    const filtered = originalData.filter((item) =>
      item.caption?.toLowerCase().includes(value)
    );
    setGroupedData(groupByModule(filtered));
  };

  const saveState = () => saveColumnState("general-setting", columnApiRef);
  const restoreState = () =>
    restoreColumnState("general-setting", columnApiRef);
  const resetState = () => resetColumnState("general-setting", columnApiRef);

  return (
    <div>
      <PageTitle name="Settings | General" />

      <div className={`${isDark ? "ag-theme-quartz-dark" : "ag-theme-quartz"}`}>
        <Card style={{ height: `calc(100vh - 4rem)`, overflow: "auto" }}>
          <Card.Header className="d-flex justify-content-between align-items-center border-bottom">
            {/* <h5 className="fs-9 mb-0 text-nowrap py-2 py-xl-0">
              Settings | General
            </h5> */}
            <BreadCrumbTable title="Settings" subTitle="General" />
            <div className="d-flex align-items-center gap-2">
              <Form className="position-relative">
                <FontAwesomeIcon
                  icon="search"
                  className="position-absolute text-400 search-box-icon"
                  style={{
                    left: "10px",
                    top: "50%",
                    transform: "translateY(-50%)",
                  }}
                />
                <Form.Control
                  type="search"
                  placeholder="Search..."
                  style={{ paddingLeft: "30px" }}
                  aria-label="Search"
                  id="filter-text-box"
                  className="rounded-pill search-input"
                  onChange={onFilterTextBoxChanged}
                />
              </Form>

              <TableHeaderDropdown>
                <div className="py-2">
                  <Dropdown.Item onClick={saveState}>Save State</Dropdown.Item>
                  <Dropdown.Item onClick={restoreState}>
                    Restore State
                  </Dropdown.Item>
                  <Dropdown.Item onClick={resetState}>
                    Reset State
                  </Dropdown.Item>
                </div>
              </TableHeaderDropdown>
            </div>
          </Card.Header>

          {/* <Card.Body className="p-0">
            <Accordion
            //  defaultActiveKey="0"
            >
              {Object.entries(groupedData).map(([module, items], idx) => (
                <Accordion.Item eventKey={String(idx)} key={module}>
                  <Accordion.Header>{module}</Accordion.Header>
                  <Accordion.Body className="p-0">
                    <div
                      className={`ag-theme-quartz${isDark ? "-dark" : ""}`}
                      style={{ width: "100%" }}
                    >
                      <AgGridReact
                        ref={columnApiRef}
                        rowData={items}
                        columnDefs={colDefs}
                        defaultColDef={defaultColDef}
                        // pagination
                        // paginationPageSize={settings.paginationSize}
                        onRowDoubleClicked={(params) =>
                          handleRowClick(params.data)
                        }
                        domLayout="autoHeight"
                        overlayNoRowsTemplate="Nothing found - Looks empty over here"
                      />
                    </div>
                  </Accordion.Body>
                </Accordion.Item>
              ))}
            </Accordion>
          </Card.Body> */}
          <Card.Body className="p-0">
            {loading ? (
              <div
                className="d-flex justify-content-center align-items-center"
                style={{ height: `calc(100vh - 12rem)` }}
              >
                <Button variant="falcon-default" size="sm" className="fs-10">
                  Loading...
                </Button>
              </div>
            ) : (
              <Accordion>
                {Object.entries(groupedData).map(([module, items], idx) => (
                  <Accordion.Item eventKey={String(idx)} key={module}>
                    <Accordion.Header>
                      <span style={{ fontSize: "0.9rem" }}>{module}</span>
                    </Accordion.Header>
                    <Accordion.Body className="p-0">
                      <div
                        className={`ag-theme-quartz${isDark ? "-dark" : ""}`}
                        style={{ width: "100%" }}
                      >
                        <AgGridReact
                          ref={columnApiRef}
                          rowData={items}
                          columnDefs={colDefs}
                          defaultColDef={defaultColDef}
                          onRowDoubleClicked={(params) =>
                            handleRowClick(params.data)
                          }
                          domLayout="autoHeight"
                          overlayNoRowsTemplate="Nothing found - Looks empty over here"
                        />
                      </div>
                    </Accordion.Body>
                  </Accordion.Item>
                ))}
              </Accordion>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  );
}
